
var snippets = function(){

	var container = $('.edit.snippet, .create.snippet');

};

jQuery(document).ready( function($){

	if( $('.create.snippet, .edit.snippet').length ) {
		var app = new snippets();
		$.fn.ensphere.veto.wysiwyg( '.redactor' );
	}

});
